module.exports = __webpack_public_path__ + "img/switch.b83321f8.svg";